export enum TestSessionStatus {
	Normal = 0,
	Started = 1,
	Saved = 2,
	UserMoved = 3,
}
